export class TimeTool {

    /**
     * @param {number} seconds
     * @param {boolean} showSeconds
     * @return {string}
     */
    static formatDurationFromSeconds(seconds, showSeconds=true) {
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let displayMinutes = hours*60-minutes;

        let displayedHours = Math.abs(hours);

        let hourString = displayedHours < 100 ? ('0' + Math.abs(hours)).slice(-2) : displayedHours;


        if (!showSeconds) {
            return hourString + ':' +
                ('0' + Math.abs(displayMinutes)).slice(-2);
        }

        let displaySeconds =  Math.floor(seconds-minutes*60);
        return hourString + ':' +
            ('0' + Math.abs(displayMinutes)).slice(-2) + ':' +
            ('0' + Math.abs(displaySeconds)).slice(-2);
    }

    /**
     * @param {?Date} now
     * @return {string}
     */
    static dayAsString(now=null) {
        now = now ? now : new Date();
        let month = ('00' + (now.getMonth()+1)).slice(-2);
        let day = ('00' + (now.getDate())).slice(-2);
        return `${now.getFullYear()}-${month}-${day}`;
    }

    /**
     * @param {?string} now
     * @return {Date}
     */
    static dayAsDate(now=null) {
        if (!now) {
            return new Date();
        }
        return new Date(now);
    }

    /**
     * @param {number} no
     * @return {string}
     */
    static weekdayName(no) {
        switch (no) {
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            case 6:
                return 'Saturday';
            case 7:
            case 0:
                return 'Sunday';
        }
        return "";
    }
}